/**
 * @desc - ページの頭に戻るリンク
 * @link - http://tsumaboku.com/return-to-top-button
 */
 
$(function(){
  var topBtn = $('.sw-ReTop');
        topBtn.hide(); //最初は非表示
        $(window).scroll(function() {
      if ($(this).scrollTop() > 700) { //700以上、下にスクロールされた時
        topBtn.fadeIn(""); //表示
      } else { //それ意外は
        topBtn.fadeOut(""); //非表示
    }
  });
});